import API from "api/axiosInstance";
import { setIsLoading, setListAspirasi, setMessage, setStatus } from "./index";

export const fetchListAspirasi = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.get("/aspirasi/get");
    dispatch(setIsLoading(false));
    dispatch(setListAspirasi(response.data.data));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};

export const fetchAddPanduan = (reqData) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const formData = new FormData();
    formData.append("nama_sop", reqData.nama_sop);
    formData.append("file_sop", reqData.file_sop);

    const response = await API.post("/panduan/add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(
      setMessage(error?.response?.data?.message ?? "Ada Kendala di Server")
    );
    dispatch(setStatus("failed"));
  }
};

export const fetchDeletePanduan = (id) => async (dispatch) => {
  dispatch(setIsLoading(true));
  try {
    const response = await API.delete(`/panduan/delete/${id}`);
    dispatch(setMessage(response.data.message));
    dispatch(setStatus("success"));
    dispatch(setIsLoading(false));
  } catch (error) {
    dispatch(setIsLoading(false));
    dispatch(setStatus("failed"));
  }
};
